import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {DataSourceRouted} from '../../util/data-source-routed';
import {JurisdicaoLocal} from '../jurisdicao-local.model';
import {JurisdicaoLocalService} from '../jurisdicao-local.service';
import { MensagemService, ProgressoService, Restricao, RestricaoOperador, Restricoes } from 'maestro-ng';
import {ActivatedRoute, Router} from '@angular/router';
import {FonteDados} from '../../fonte-dados/fonte-dados.model';
import {FonteDadosService} from '../../fonte-dados/fonte-dados.service';
import {SelectItem} from 'primeng/api';
import {SelectItemService} from '../../services/select-item.service';

@Component({
  selector: 'app-jurisdicao-local-lista',
  templateUrl: './jurisdicao-local-lista.component.html',
  styleUrls: ['./jurisdicao-local-lista.component.css']
})
export class JurisdicaoLocalListaComponent implements OnInit, OnChanges {
  public ds: DataSourceRouted<JurisdicaoLocal, number>;

  @Input()
  fonteDados: FonteDados;

  public exibirOrigemIdGlobal: boolean = false;
  public colunaTituloGeral: string = 'Id';

  public situacaoItens: SelectItem[];

  constructor(
    private service: JurisdicaoLocalService,
    private fonteDadosService: FonteDadosService,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private selectItemService: SelectItemService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.ds = new DataSourceRouted<JurisdicaoLocal, number>(
      'administracao-jurisdicaoLocal',
      (c) => this.service.recuperarPaginado(c),
      this.mensagemService, this.progressoService,
      this.route,
      this.router,
      15,
      new Restricoes(
        [
          new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
          new Restricao<string>({ atributo: 'descricao', operador: RestricaoOperador.CONTAINS }),
          new Restricao<string>({ atributo: 'situacao', operador: RestricaoOperador.EQUALS }),
          new Restricao<number>({ atributo: 'fonteDados.id', operador: RestricaoOperador.EQUALS })
        ]
      )
    );
  }

  ngOnInit(): void {
    this.situacaoItens = this.selectItemService.getSituacaoItens();
    const savedState = localStorage.getItem('exibirOrigemIdGlobal');
    this.exibirOrigemIdGlobal = savedState === 'true';
    this.colunaTituloGeral = this.exibirOrigemIdGlobal ? 'Origem Id' : 'Id';
  }

  ngOnChanges(_: SimpleChanges): void {
    if (this.fonteDados !== undefined && this.fonteDados?.id !== undefined) {
      this.ds.restricoes.atributo('fonteDados.id').valor = this.fonteDados.id;
      this.ds.pesquisar();
    }
  }
  limpar(): void {
    this.ds.restricoes.limpar();
    this.ds.restricoes.atributo('fonteDados.id').valor = this.fonteDados.id;
    this.ds.pesquisar();
  }

  sincronizar(): void {
    this.progressoService.modal();
    this.service.sincronizar(this.fonteDados)
      .then(() => {
        this.mensagemService.addSucesso('Sucesso', 'As Jurisdições locais foram sincronizadas com sucesso!');
        this.ds.atualizar();
        this.progressoService.fechar();
      })
      .catch((response) => {
        this.ds.atualizar();
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro', response.error);
      });
  }
  sincronizarPorId(entidade: JurisdicaoLocal): void {
    this.progressoService.modal();
    this.service.sincronizarPorId(entidade.id)
      .then(() => {
        this.mensagemService.addSucesso('Sucesso', 'A Jurisdição local  foi sincronizada com sucesso!');
        this.ds.atualizar();
        this.progressoService.fechar();
      })
      .catch((response) => {
        this.ds.atualizar();
        this.progressoService.fechar();
        this.mensagemService.addErro('Erro', response.error);
      });
  }

  public alternarColunaGlobal(showOrigemId: boolean) {
    this.exibirOrigemIdGlobal = showOrigemId;
    this.colunaTituloGeral = showOrigemId ? 'Origem Id' : 'Id';
    localStorage.setItem('exibirOrigemIdGlobal', String(showOrigemId));
  }
}
